<template>
  <div class="pt-1">
    <div>
      <vue-perfect-scrollbar
        class="comment-scroll-area"
        style="min-height: 500px;"
      >
        <b-media
          v-for="(comment, index) in getComments.results"
          :key="index"
          class="mb-2"
        >
          <template #aside>
            <b-avatar
              v-b-tooltip.hover
              :src="backendIP + comment.author.photo"
              class="pull-up"
              button
              :title="comment.author.first_name"
              size="40"
              variant="primary"
            />
          </template>

          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6>{{ comment.author.first_name }}</h6>
            <!-- <small class="timeline-item-time text-nowrap text-muted ml-1 mr-1">{{prettifyDate(comment.created_date)}}</small> -->
          </div>
          <b-card-text class="mb-25">
            {{ comment.message }}
          </b-card-text>

          <b-button
            v-if="$can('create', 'utils/comment')"
            variant="link"
            class="timeline-item-time text-nowrap font-small-2 pl-0 pr-50"
            @click="replyToComment(comment.message, comment.id)"
          >
            {{ $t('clients.reply') }}
          </b-button>
          <b-button
            v-if="comment.author.id == getUserId"
            variant="link"
            class="timeline-item-time text-nowrap font-small-2 pl-25"
            @click="deleteComment(comment.id)"
          >{{ $t('generals.delete') }}</b-button>

          <b-media
            v-for="reply_comment in comment.children"
            :key="reply_comment.id"
            class="mt-1"
          >
            <template #aside>
              <b-avatar
                v-b-tooltip.hover
                class="pull-up"
                button
                :title="reply_comment.author.first_name"
                size="40"
                variant="primary"
                :src="backendIP + reply_comment.author.photo"
              />
            </template>

            <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
              <h6>{{ reply_comment.author.first_name }}</h6>
              <!-- <small class="timeline-item-time text-nowrap text-muted ml-1 mr-1">{{prettifyDate(reply_comment.created_date)}}</small> -->
            </div>
            <b-card-text class="mb-0">
              {{ reply_comment.message }}
            </b-card-text>
            <b-button
              variant="link"
              class="timeline-item-time text-nowrap font-small-2 p-0 pr-50"
              @click="replyToComment(reply_comment.message, reply_comment.id)"
            >{{ $t('clients.reply') }}</b-button>
            <b-button
              v-if="reply_comment.author.id == getUserId"
              variant="link"
              class="timeline-item-time text-nowrap font-small-2 pl-25"
              @click="deleteComment(reply_comment.id)"
            >{{ $t('generals.delete') }}</b-button>
          </b-media>

        </b-media>
      </vue-perfect-scrollbar>

      <b-form-group>
        <label for="textarea-default">
          <span v-if="reply">
            {{ $t('clients.reply_to') }}: <strong class="">{{ reply_to_message }}</strong>
            <feather-icon
              icon="XIcon"
              class="text-danger mb-50"
              style="cursor: pointer;"
              @click="CancelReply"
            />
          </span>
          <span v-if="!reply">{{ $t('clients.comment_on') }}</span>
        </label>
        <b-form-textarea
          v-model="message"
          name="textarea"
          rows="3"
          :placeholder="$t('clients.message_text')"
        />
      </b-form-group>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="md"
        @click="addComment"
      >
        {{ $t('clients.publish') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  BMedia, VBTooltip, BCardText, BButton, BFormGroup, BFormTextarea, BAvatar,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import contentType from '@/utils/contentTypes'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BMedia,
    BCardText,
    BButton,
    BAvatar,
    BFormGroup,
    BFormTextarea,
    VuePerfectScrollbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      backendIP: '',
      message: '',
      myContentType: {},
      reply_to_message: '',
      reply: false,
      parent_message_id: null,
    }
  },
  computed: {
    ...mapGetters('clients', ['getComments']),
    getUserId() {
      return getUserData().id
    },
  },
  methods: {
    ...mapActions('clients', ['POST_COMMENT', 'FETCH_COMMENTS', 'DELETE_COMMENT']),

    async refresh() {
      await this.FETCH_COMMENTS({ object_id: this.$route.params.id, content_type: contentType['clients/client'] })
    },
    async addComment() {
      const newComment = {
        author: this.getUserId,
        object_id: this.$route.params.id,
        content_type: contentType['clients/client'],
        message: this.message,
      }

      if (this.parent_message_id) {
        newComment.parent = this.parent_message_id
      }

      await this.POST_COMMENT(newComment)
      await this.refresh()
      this.message = ''
      this.CancelReply()
    },
    replyToComment(message, id) {
      this.reply_to_message = message
      this.reply = true
      this.parent_message_id = id
    },
    CancelReply() {
      this.reply_to_message = ''
      this.reply = false
      this.parent_message_id = null
    },
    deleteComment(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t('clients.are_you_sure'), {
          title: this.$t('clients.confirm'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('generals.ok'),
          cancelTitle: this.$t('generals.no'),
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(async value => {
          if (value) {
            await this.DELETE_COMMENT(id)
            this.refresh()
          }
        })
    },

  },
  mounted() {
    this.refresh()
  },
}
</script>

<style>

</style>
